/** Source of truth for "already played" — asks the backend for a completed `stat` row for this user, not a client-side flag. */
export async function checkLsPlayed({ token, userId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/checkLsPlayed`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ user_id: userId }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to check played status");
  }

  return resp.json();
}
